{
  "dashboard": {
    "title": "Mon environnement de travail",
    "subtitle": "Votre contribution personnelle à l'entreprise – processus, effort, systèmes et réseau.",

    "stats": {
      "activeProcesses": "Processus actifs",
      "activeProcessesDesc_one": "Implication",
      "activeProcessesDesc_other": "Implications",
      "totalActivities_one": "Activité dans les processus",
      "totalActivities_other": "Activités dans les processus",
      "usedSystems": "Systèmes utilisés",
      "usedSystemsDesc_one": "Système",
      "usedSystemsDesc_other": "Systèmes",
      "networkInteractions": "Réseau",
      "networkDesc_one": "Personne",
      "networkDesc_other": "Personnes",
      "direct": "Direct",
      "indirect": "Indirect"
    },
    "capacity": {
      "title": "Répartition des capacités",
      "subtitle": "Effort par processus (h/mois)"
    },
    "processes": {
      "title": "Processus et activités",
      "activities_one": "{{count}} Activité",
      "activities_other": "{{count}} Activités",
      "noProcesses": "Aucun processus pour le moment"
    },
    "activities": {
      "unnamed": "{{type}} (en cours)"
    },
    "systems": {
      "title": "Mes systèmes",
      "processCount_one": "{{count}} Processus",
      "processCount_other": "{{count}} Processus",
      "noSystems": "Aucun système pour le moment"
    },
    "coWorkers": {
      "title": "Mon réseau",
      "all": "Tous",
      "direct": "Direct",
      "upstream": "En amont",
      "downstream": "En aval",
      "noCoWorkers": "Aucun co-worker trouvé",
      "noCoWorkersDirect": "Aucun co-worker direct trouvé",
      "noCoWorkersUpstream": "Aucun co-worker en amont trouvé",
      "noCoWorkersDownstream": "Aucun co-worker en aval trouvé"
    },
    "hoursSuffix": "{{value}}h"
  }
}
